export const mutations = {
  /**
   * Mutation to set widget
   */
  setWidget(state, widget) {
    state.widget = widget;
  }
};
